import { SVGProps } from 'react';

export const SunIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_sun)">
			<path
				d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
				stroke="currentColor"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_sun">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const NotificationIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M4.33301 20.5833V18.4167H6.49967V10.8333C6.49967 9.33472 6.95106 8.00764 7.85384 6.85208C8.75662 5.67847 9.93023 4.91111 11.3747 4.55V3.79167C11.3747 3.34028 11.5281 2.96111 11.8351 2.65416C12.1601 2.32917 12.5483 2.16667 12.9997 2.16667C13.4511 2.16667 13.8302 2.32917 14.1372 2.65416C14.4622 2.96111 14.6247 3.34028 14.6247 3.79167V4.55C16.0691 4.91111 17.2427 5.67847 18.1455 6.85208C19.0483 8.00764 19.4997 9.33472 19.4997 10.8333V18.4167H21.6663V20.5833H4.33301ZM12.9997 23.8333C12.4038 23.8333 11.8893 23.6257 11.4559 23.2104C11.0406 22.7771 10.833 22.2625 10.833 21.6667H15.1663C15.1663 22.2625 14.9497 22.7771 14.5163 23.2104C14.1011 23.6257 13.5955 23.8333 12.9997 23.8333ZM8.66634 18.4167H17.333V10.8333C17.333 9.64166 16.9087 8.62153 16.0601 7.77292C15.2115 6.9243 14.1913 6.5 12.9997 6.5C11.808 6.5 10.7879 6.9243 9.93926 7.77292C9.09065 8.62153 8.66634 9.64166 8.66634 10.8333V18.4167Z"
			strokeWidth="2.5"
			fill="currentColor"
		/>
	</svg>
);
